import React from 'react'
import { useIntl } from 'react-intl'

import styled from 'styled-components/native'

import { IconBadge } from '../../atoms/iconBadge/IconBadge'
import { BadgeShape, BadgeVariant } from '../../badge/constants'

const Container = styled.View(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing['8px'],
  alignItems: 'center',
}))

export type ClientDetailsEpisodeTagsProps = {
  programName: string | null
  isActive: boolean
}

export const ClientDetailsEpisodeTags: React.FC<ClientDetailsEpisodeTagsProps> = ({ programName, isActive }) => {
  const { formatMessage } = useIntl()
  const activeLabel = formatMessage({ defaultMessage: 'Active', description: 'Active episode' })
  const inactiveLabel = formatMessage({ defaultMessage: 'Inactive', description: 'Inactive episode' })
  return (
    <Container>
      <IconBadge text={isActive ? activeLabel : inactiveLabel} variant={BadgeVariant.NEUTRAL} shape={BadgeShape.RECT} />
      {programName && <IconBadge text={programName} variant={BadgeVariant.NEUTRAL} shape={BadgeShape.RECT} />}
    </Container>
  )
}
